import React from "react";
import { injectIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import estrella from "../assets/estrella.png";
import logoMedical from "../assets/logo-medical.png";
import { useGameTexts } from "../hooks/useGameTexts";
import { formatScoreTopBar } from "../utils/helpers";

function Gameover({ intl }) {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const location = useLocation();
	const group = useSelector((state) => state.group);
	const score = useSelector((state) => state.group?.score);
	const { texts, ready } = useGameTexts(group?.game);

	const footerRef = texts["end.footerRef"] ?? "";
	const footerDate = texts["end.footerDate"] ?? "";

	return (
		<div className="h-100">
			<div className="container-fluid bg-internas">
				<div style={{ paddingTop: "6vh", paddingLeft: "6vh" }}>
					<img width={240} src={logoMedical} />
				</div>
				<div
					className="row d-flex justify-content-center align-items-center"
					style={{ marginTop: "15vh", minHeight: "50vh" }}
				>
					<div className="col-8">
						{!ready ? (
							<div className="txtWhite">Cargando...</div>
						) : (
						<div className="ps-5 txt16 text-center">
							<div
								className="txt20 bold txt-yellow-light mt-4"
								style={{ lineHeight: "30px" }}
							>
								Lo sentimos el tiempo de juego ha finalizado.{" "}
							</div>
							<div className="txt-white mt-4">
								Muchas gracias por tu participación.
							</div>
							<div className="txt-white mt-4 bold">
								¿Quieres conocer tu puntuación?{" "}
							</div>
							<div className="d-flex justify-content-center align-items-center mt-4">
								{Array.from({ length: 5 }).map((_, index) => (
									<img
										key={index}
										src={estrella}
										className="me-2"
										alt="star"
										width="25px"
									/>
								))}
							</div>
							<div
								className="txt-white mt-4 bold txt30"
								style={{ letterSpacing: "3px" }}
							>
								{formatScoreTopBar(score)}
							</div>
						</div>
						)}
					</div>
					<div
						className="txtWhite d-flex flex-column align-items-end txt12 text-right"
						style={{
							position: "absolute",
							bottom: "8vh",
							right: "5vh",
						}}
					>
						<div dangerouslySetInnerHTML={{ __html: footerRef }} />
						<div dangerouslySetInnerHTML={{ __html: footerDate }} />
					</div>
				</div>
			</div>
		</div>
	);
}

export default injectIntl(Gameover);
